import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";
import * as userData from "@/auth/localStorageUtils.js";

const search = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/MediateDirectorGroup/Search",
    params
  );
};

const getById = (id) => {
  const params = {
    id,
  };

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/MediateDirectorGroup/GetById",
    params
  );
};

const updateItem = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/MediateDirectorGroup/Update?userId=" +
      userData.userId(),
    params
  );
};

const updateItemActive = (id, isActive) => {
  const params = {
    id,
    isActive,
    userId: userData.userId(),
  };

  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/MediateDirectorGroup/UpdateActive",
    params
  );
};

const deleteItem = (id) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/MediateDirectorGroup/Delete?id=" +
      id +
      "&userId=" +
      userData.userId()
  );
};

const swapOrder = (id1, id2) => {
  return axiosget(
    appsettings.ocpbComplaintAPIUrl +
      "api/MediateDirectorGroup/SwapOrder?userId=" +
      userData.userId() +
      "&id1=" +
      id1 +
      "&id2=" +
      id2
  );
};

export { search, getById, updateItem, updateItemActive, deleteItem, swapOrder };
